if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.minicart = document.querySelector("mini-cart");
        this.quickViewDrawer = this.closest("quick-view-drawer");
        this.eventContext = this.form.dataset.eventContext;
        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(event) {
        event.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains("loading")) return;

        this.handleErrorMessage();
        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");
        this.querySelector(".button-overlay-spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        formData.append("sections", this.minicart.getSectionsToRender().map(s => s.section));
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        // Cart-recommendation adds hit the same edge 429 checkpoint as the
        // delivery switch. Grey-out the OTHER recommendation add buttons (and the
        // cart quantity controls) so a second concurrent write can't fire, and
        // fail fast on 429 so we reload + replay instead of stalling ~15s.
        const isReco = !!this.closest(".cart-recommendations-wrapper");
        let recoFadeEls = null;
        if (isReco && window.CartRecovery) {
          recoFadeEls = [];
          document.querySelectorAll('.cart-recommendations-wrapper product-form [type="submit"]').forEach((b) => { if (b !== submitButton && !b.disabled) recoFadeEls.push(b); });
          document.querySelectorAll("#main-cart-items quantity-input button, #main-cart-items .quantity-input-field").forEach((el) => recoFadeEls.push(el));
          window.CartRecovery.fadeGroup(recoFadeEls);
          config.failFastOn429 = true;
        }

        // PLP: fade all other add-to-cart buttons while this request is in flight
        // so a rapid second click can't queue a concurrent cart write and trigger 429.
        let plpFadeEls = null;
        if (!isReco && window.CartRecovery) {
          plpFadeEls = [];
          document.querySelectorAll('product-form [type="submit"], drawer-toggle[for="QuickViewDrawer"] button').forEach(b => {
            if (b !== submitButton && !b.disabled) plpFadeEls.push(b);
          });
          if (plpFadeEls.length) window.CartRecovery.fadeGroup(plpFadeEls);
          else plpFadeEls = null;
        }

        const _cartFetch = (window.CartQueue ? window.CartQueue.fetch : fetch);
        _cartFetch(`${routes.cart_add_url}`, config)
            .then(response => {
              if (response.status === 429 && isReco && window.CartRecovery) {
                // Edge checkpoint — reload + replay this add after navigation clears it.
                // Persist the FULL form (incl. line-item properties) so the
                // replay merges into the existing line instead of duplicating it.
                if (window.CartRecovery.reloadAndReplay("reco_add", window.CartRecovery.serializeForm(formData))) {
                  return null; // page is reloading
                }
                showTranslatedToast("cart_error", "error", "single"); // reload budget spent
                return null;
              }
              if (response.status === 429 && !isReco && window.CartRecovery) {
                if (window.CartRecovery.reloadAndReplay("plp_add", window.CartRecovery.serializeForm(formData))) {
                  return null; // page is reloading
                }
                showTranslatedToast("cart_error", "error", "single"); // reload budget spent
                return null;
              }
              return response.json();
            })
            .then(response => {
              if (response === null) return; // 429 handled above
              if (isReco && window.CartRecovery) window.CartRecovery.clearReplay("reco_add");
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);
                //Show error toast
                showTranslatedToast("cart_error", "error", "single");
                this.minicart.updateSectionContents();
                return;
              }

              //Update mini cart contents silently (no open)
              this.minicart.renderContents(response);

              // If on the cart page, re-render #main-cart-items so the new
              // item appears without a full page reload.
              const cartItemsEl = document.querySelector('cart-items');
              if (cartItemsEl && typeof cartItemsEl.updateSectionContents === 'function') {
                // For reco adds, fail fast on the render GET: the add already
                // succeeded, so if the section render hits the edge checkpoint
                // we reload the cart (capped) to show the item past it — we do
                // NOT replay the add (it's already in the cart, avoid dupes).
                cartItemsEl.updateSectionContents(isReco).then(function() {
                  document.dispatchEvent(new CustomEvent('cart:sections:updated'));
                }).catch(function(err) {
                  if (isReco && window.CartRecovery && window.CartRecovery.is429(err)) {
                    window.CartRecovery.reloadAndReplay('reco_render', {}, 2);
                  }
                });
              }

              if (window.themeSettings.redirectToCart) {
                location.href = window.routes.cart_url;
              } else {
                // CHANGE 1: Show success toast and redirect to cart on click
                showTranslatedToast("cart_success", "success", "single");
                requestAnimationFrame(() => {
                  const allToasts = document.querySelectorAll('.toast--success, .toast[data-type="success"], .toast.success');
                  const successToast = allToasts[allToasts.length - 1]; // always grab the newest one
                  if (successToast) {
                    successToast.style.cursor = 'pointer';
                    successToast.addEventListener('click', (e) => {
                      // CHANGE 2: If the click was on the close button (or inside it), do not redirect
                      if (e.target.closest('.toast__close, .toast-close, [data-toast-close], button')) return;
                      location.href = window.routes.cart_url;
                    }, { once: true });
                  }
                });
                if (this.quickViewDrawer) {
                  this.quickViewDrawer.close();
                }
              }

              const event = new CustomEvent("cart:item-add", {
                detail: { items: [response], context: this.eventContext }
              });
              document.dispatchEvent(event);

              publish(PUB_SUB_EVENTS.cartItemAdd, {
                source: this.eventContext,
                items: [response],
              });
            })
            .catch(e => {
              console.error(e);
              //Show generic error toast on network/unexpected failure
              showTranslatedToast("cart_error", "error", "single");
            })
            .finally(() => {
              submitButton.classList.remove("loading");
              submitButton.removeAttribute("aria-disabled");
              this.querySelector(".button-overlay-spinner").classList.add("hidden");
              if (recoFadeEls && window.CartRecovery) window.CartRecovery.unfadeGroup(recoFadeEls);
              if (plpFadeEls && window.CartRecovery) window.CartRecovery.unfadeGroup(plpFadeEls);
            });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) {
          return;
        }

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector(".product-form-error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(".product-form-error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}

// Replay a cart-recommendation add-to-cart that failed at the edge 429
// checkpoint before a reload. Cart page only (guarded by the recommendations
// wrapper). Routes through CartQueue so it can't collide with other cart
// writes; capped by CartRecovery's reload budget.
(function () {
  if (!window.CartRecovery) return;
  function replayRecoAdd() {
    if (!document.querySelector(".cart-recommendations-wrapper")) return;
    // A fresh cart load means the section render succeeded past the checkpoint,
    // so reset the render-recovery reload budget.
    window.CartRecovery.clearReplay("reco_render");
    var pending = window.CartRecovery.getReplay("reco_add");
    if (!pending || !pending.id) return;
    // Replay with the full original form (incl. properties[...]) so Shopify
    // merges into the existing line item rather than adding a duplicate.
    var body = window.CartRecovery.toFormData(pending);
    var _cartFetch = (window.CartQueue ? window.CartQueue.fetch : fetch);
    _cartFetch(window.routes.cart_add_url, {
      method: "POST",
      headers: { "X-Requested-With": "XMLHttpRequest", "Accept": "application/javascript" },
      body: body,
      failFastOn429: true
    })
      .then(function (r) {
        if (r.status === 429) {
          window.CartRecovery.reloadAndReplay("reco_add", pending); // try once more (capped)
          return null;
        }
        window.CartRecovery.clearReplay("reco_add");
        return r.json();
      })
      .then(function (res) {
        if (!res || res.status) return;
        var cartItemsEl = document.querySelector("cart-items");
        if (cartItemsEl && typeof cartItemsEl.updateSectionContents === "function") {
          cartItemsEl.updateSectionContents()
            .then(function () { document.dispatchEvent(new CustomEvent("cart:sections:updated")); })
            .catch(function () {});
        }
        if (typeof showTranslatedToast === "function") showTranslatedToast("cart_success", "success", "single");
      })
      .catch(function () { window.CartRecovery.clearReplay("reco_add"); });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", replayRecoAdd, { once: true });
  } else {
    replayRecoAdd();
  }
})();

// Replay a PLP add-to-cart that hit the edge 429 checkpoint and was deferred via
// reloadAndReplay("plp_add"). Runs on every page load; no-ops when no entry exists.
(function () {
  if (!window.CartRecovery) return;
  function replayPlpAdd() {
    var pending = window.CartRecovery.getReplay("plp_add");
    if (!pending || !pending.id) return;

    // Replay with the full original form (incl. properties[...]) so Shopify
    // merges into the existing line item rather than adding a duplicate.
    var body = window.CartRecovery.toFormData(pending);
    var _cartFetch = window.CartQueue ? window.CartQueue.fetch : fetch;
    _cartFetch(window.routes.cart_add_url, {
      method: "POST",
      headers: { "X-Requested-With": "XMLHttpRequest", "Accept": "application/javascript" },
      body: body,
      failFastOn429: true
    })
      .then(function (r) {
        if (r.status === 429) {
          window.CartRecovery.reloadAndReplay("plp_add", pending); // capped by budget
          return null;
        }
        window.CartRecovery.clearReplay("plp_add");
        return r.json();
      })
      .then(function (res) {
        if (!res || res.status) return;
        var minicart = document.querySelector("mini-cart");
        if (minicart && typeof minicart.updateSectionContents === "function") minicart.updateSectionContents();
        if (typeof showTranslatedToast === "function") showTranslatedToast("cart_success", "success", "single");
      })
      .catch(function () { window.CartRecovery.clearReplay("plp_add"); });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", replayPlpAdd, { once: true });
  } else {
    replayPlpAdd();
  }
})();